var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('v-tooltip', {
    attrs: {
      "top": "",
      "nudge-right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_vm.billing.type === _vm.BillingTypeEnum.CREDIT ? _c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              _vm.cancelBillingDialog = true;
            }
          }
        }, on), [_c('v-icon', [_vm._v("mdi-cancel")])], 1) : _vm._e()];
      }
    }])
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgBillingCancellationDialog.cancelTooltip")) + " ")])]), _vm.cancelBillingDialog ? _c('v-dialog', {
    attrs: {
      "max-width": "600"
    },
    model: {
      value: _vm.cancelBillingDialog,
      callback: function callback($$v) {
        _vm.cancelBillingDialog = $$v;
      },
      expression: "cancelBillingDialog"
    }
  }, [_c('card', {
    attrs: {
      "title": _vm.$t('components.thg.ThgBillingCancellationDialog.cancelTitle'),
      "subtitle": '#' + _vm.billing.billingNumber,
      "margin": 0
    },
    scopedSlots: _vm._u([{
      key: "main",
      fn: function fn() {
        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "text": "",
            "outlined": ""
          },
          on: {
            "click": _vm.cancelBillingCancellation
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgBillingCancellationDialog.cancelCancellation")) + " ")]), _c('v-spacer'), _c('v-btn', {
          attrs: {
            "loading": _vm.loading,
            "text": "",
            "outlined": ""
          },
          on: {
            "click": _vm.confirmBillingCancellation
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgBillingCancellationDialog.confirmCancellation")) + " ")])], 1)];
      },
      proxy: true
    }], null, false, 2229794653)
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }